const withInitialProps = (initialProps) => (Component) => (props) => <Component {...initialProps} {...props} />;

export default withInitialProps;
